import { initializeApp } from "firebase/app";
import { getAuth, signInAnonymously } from "firebase/auth";
import {
  getFirestore,
  doc,
  setDoc,
  query,
  where,
  getDocs,
  getDoc,
  collection,
  updateDoc,
  increment,
  decrement,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";
import CryptoJS from "crypto-js";
import { getVideoStatus } from "./Script";
import axios from "axios";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_apikey,
  authDomain: process.env.REACT_APP_authDomain,
  projectId: process.env.REACT_APP_projectId,
  storageBucket: process.env.REACT_APP_storageBucket,
  messagingSenderId: process.env.REACT_APP_messagingSenderId,
  appId: process.env.REACT_APP_appId,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const secretKey = "MobYhEGrLSyDxbox";
const ivString = "moBQZcTleSVNlbOx";

let getCountryCodePromise = null;

export async function getCountryCode() {
  if (!getCountryCodePromise) {
    getCountryCodePromise = (async () => {
      try {
        const res = await fetch(
          "https://dz5yc9ggwa4v9.cloudfront.net/Lambda/GetCountry",
          { method: "GET" }
        );
        if (!res.ok) throw new Error("Country API failed");
        return (await res.text()).trim();
      } catch (e) {
        console.warn("getCountryCode fallback -> OTHER", e);
        return "OTHER";
      }
    })();
  }
  return getCountryCodePromise;
}
export async function ensureStreamingLimitByCountry(phone, sec) {
  try {
    const country = await getCountryCode(); // "AE" or other
    const target = country === "AE" ? 900 : 120;

    const userRef = doc(db, "users", phone); // your docs are keyed by phone
    const snap = await getDoc(userRef);
    if (!snap.exists()) return country;

    const data = snap.data();
    const current = Number(data?.streaming_limit ?? 0);

    // only bump up if below the target
    if (current < sec) {
      await updateDoc(userRef, { streaming_limit: sec });

      // keep sessionStorage in sync if present
      const s = JSON.parse(sessionStorage.getItem("AI_UserData") || "{}");
      s.streaming_limit = sec;
      sessionStorage.setItem("AI_UserData", JSON.stringify(s));
    }

    return country;
  } catch (e) {
    console.warn("ensureStreamingLimitByCountry error:", e);
    return "OTHER";
  }
}
const now = new Date();
const formattedDate = now.toISOString().slice(0, 10); // Format as 'YYYY-MM-DD'

export async function logPageVisit(url, extra = {}) {
  try {
    const aiUserRaw = sessionStorage.getItem("AI_UserData");
    const aiUser = aiUserRaw ? JSON.parse(aiUserRaw) : {};
    const uuid = aiUser?.uuid || null;
    const phone = aiUser?.phone || null;

    const u = new URL(url, window.location.origin);

    // One-string representation of ALL query params (e.g. "jwt_token=96170932819&name=elfar")
    const query_str = u.searchParams.toString();

    const payload = {
      url: u.href,
      path: u.pathname,
      query_str, // ✅ single string with every query param
      referrer: document.referrer || null,
      ua: navigator.userAgent,
      uuid,
      phone,
      ts: serverTimestamp(),
    };

    await addDoc(collection(db, "page_visits"), payload);
    await UpdateAnalytics("visits"); // optional daily counter
  } catch (e) {
    console.error("logPageVisit error:", e);
  }
}

export async function MobiSignin(Phonenumber, Password, Country, ProviderID) {
  // Remove spaces from phone number
  let phoneNumberForAPI = Phonenumber ? Phonenumber.replace(/\s/g, '') : Phonenumber;
  // Remove "+" and leading zeros from phone number for API call
  phoneNumberForAPI = phoneNumberForAPI ? phoneNumberForAPI.replace(/^\+/, '') : phoneNumberForAPI;
  // Remove leading zeros
  phoneNumberForAPI = phoneNumberForAPI ? phoneNumberForAPI.replace(/^0+/, '') : phoneNumberForAPI;
  
  // Try both service IDs: 2059 and 5535
  const serviceIds = [5535,2059];
  let lastError = null;

  for (const serviceId of serviceIds) {
    try {
      const apiurl = `https://apiv2.mobileartsme.com/login?serviceid=${serviceId}&phonenumber=${phoneNumberForAPI}&password=${Password}&type=signin&country=${Country}`;
      const response = await axios.get(apiurl);

      console.log(`MobiSignin attempt with serviceId ${serviceId}:`, response.data);

      if (
        (response.data.Error === 0 || response.data.Result?.Status === 0) &&
        response.data.Result.Description === "Subscription Active"
      ) {
        // Success! Proceed with login
        if (response.data.Error === 0) {
          sessionStorage.setItem(
            "AI_MobiLoginResponse",
            JSON.stringify(response.data)
          );
        }
        await checkPhoneNumberAndCreateUser(Phonenumber);
        window.location.href = `/Portal/index.html?jwt_token=${Phonenumber}`;
        return response.data;
      }
      
      // Store the response as lastError for potential return
      lastError = response.data;
    } catch (error) {
      console.error(`MobiSignin failed for serviceId ${serviceId}:`, error);
      lastError = error.response?.data || error;
    }
  }

  // If we get here, both service IDs failed
  return lastError || { Error: -1, Result: { Description: "Login failed for all service IDs" } };
}

export async function decodeJWTAndDecryptSub(token) {
  const trimmedToken = token.trim();
  const parts = trimmedToken.split(".");

  // **Condition 1: Check if it's a JWT**
  if (parts.length === 3) {
    console.log("Valid JWT detected. Decoding...");

    const payloadBase64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const decodedPayload = atob(payloadBase64);
    const decodedObj = JSON.parse(decodedPayload);
    const sub = decodedObj.sub;

    if (!sub) {
      console.log('No "sub" field found in the payload');
      return false;
    }

    // **Check if 'sub' is in HEX format and decrypt**

    if (isHex(sub)) {
      const decryptedSub = decryptAES(sub, secretKey, ivString);
      if (decryptedSub) {
        // Only keep digits, don’t slice at '/'
        const phonenumb = decryptedSub.replace(/\D+/g, "");
        console.log("Phone number extracted:", phonenumb);
        if (phonenumb) {
          CheckSubscriber(phonenumb);
        }
      }
    } else {
      console.log("Sub field is not in HEX format. It might be plain text.");
      //Add CheckSubscriber() here without password, just pass the sub
      // await checkPhoneNumberAndCreateUser(sub);
      CheckSubscriber(sub);
    }

    return true;
  }

  // **Condition 2: Check if it's a valid phone number**
  if (/^\+?\d+$/.test(trimmedToken)) {
    console.log("Token is a valid phone number:", trimmedToken);
    // Check if user is already authenticated (from previous MobiSignin call)
    const aiUserRaw = sessionStorage.getItem("AI_UserData");
    const aiUser = aiUserRaw ? JSON.parse(aiUserRaw) : {};
    const existingPhone = aiUser?.phone;
    // If user is already authenticated with the same phone number, skip redundant API call
    // MobiSignin already verified subscription status, so no need to call CheckSubscriber again
    if (existingPhone && existingPhone === trimmedToken) {
      console.log(
        "User already authenticated from successful MobiSignin, skipping redundant verification"
      );
      return true;
    }
    const urlParams = new URLSearchParams(window.location.search);

    const pass = urlParams.get("password");
    const country = urlParams.get("country");
    const provider = urlParams.get("IDProvider");

    console.log(trimmedToken, pass);
    await MobiSignin(trimmedToken, pass, country, provider); // Password and Country are unknown
    return true;
  }

  // **Condition 3: Check if it's a query string with parameters**
  console.log(
    "Invalid JWT format. Checking if it contains login parameters..."
  );
  const params = new URLSearchParams(trimmedToken);

  const Phonenumber = params.get("phonenumber");
  const Password = params.get("password");
  const Country = params.get("country");
  const ServiceId = params.get("serviceid");
  const Type = params.get("type");

  if (
    Phonenumber &&
    Password &&
    Country &&
    ServiceId === "2059" &&
    Type === "signin"
  ) {
    console.log("Detected query parameters for login. Calling MobiSignin...");
    return await MobiSignin(Phonenumber, Password, Country);
  }

  // **No valid condition met**
  console.log(
    "Token is neither a valid JWT, phone number, nor a valid query parameter string."
  );
  return false;
}

export async function CheckSubscriber(identifier) {
  try {
    // Normalize MSISDN (digits only)
    const msisdn = String(identifier).replace(/[^\d]/g, "");
    if (!msisdn) {
      // console.log("CheckSubscriber: invalid MSISDN");
      window.location.href = "/packages";
      return false;
    }

    const serviceIds = [4727, 5204, 5205, 2059];
    let active = false;

    for (const id of serviceIds) {
      const url = `https://apiv2.mobileartsme.com/LoginWithoutPass?IDService=${id}&MSISDN=${encodeURIComponent(
        msisdn
      )}&IDProvider=394`;
      const res = await fetch(url, { method: "GET" });

      if (!res.ok) {
        // console.log(`CheckSubscriber: network error for service ${id}`, res.status);
        continue; // try next ID
      }

      const data = await res.json();
      const error = Number(data?.Error);
      const description = data?.Result?.Description || "";

      if (error === 0 && description === "Subscription Active") {
        // console.log(`CheckSubscriber: active in service ${id}`);
        active = true;
        break;
      }
    }

    if (!active) {
      // console.log("CheckSubscriber: not active in any service");
      window.location.href = "/packages";
      return false;
    }

    // Active subscriber → create/find user then continue
    await checkPhoneNumberAndCreateUser(msisdn);
    return true;
  } catch (e) {
    // console.log("CheckSubscriber: exception", e);
    window.location.href = "/packages";
    return false;
  }
}

function isHex(s) {
  return (
    typeof s === "string" && /^[0-9A-Fa-f]+$/.test(s) && s.length % 2 === 0
  );
}

function decryptAES(encryptedHex, secretKey, ivString) {
  if (
    !secretKey ||
    !ivString ||
    secretKey.length !== 16 ||
    ivString.length !== 16
  ) {
    console.error("Key and IV must be 16 characters (16 bytes) long.");
    return null;
  }

  // ✅ sanity check: valid hex and even length
  if (!/^[0-9A-Fa-f]+$/.test(encryptedHex) || encryptedHex.length % 2 !== 0) {
    console.error("Invalid hex ciphertext");
    return null;
  }

  const key = CryptoJS.enc.Utf8.parse(secretKey);
  const iv = CryptoJS.enc.Utf8.parse(ivString);

  // ✅ normalize hex to lowercase before parsing
  const ciphertext = CryptoJS.enc.Hex.parse(encryptedHex.toLowerCase());
  // console.log("Ciphertext (WordArray):", ciphertext);
  try {
    const dec = CryptoJS.AES.decrypt({ ciphertext }, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    // console.log("Decrypted (WordArray):", dec);
    const txt = dec.toString(CryptoJS.enc.Utf8);
    // console.log("Decrypted (UTF-8):", txt);
    return txt || null;
  } catch (e) {
    // console.error("AES decryption failed:", e.message || e);
    return null;
  }
}

export async function checkPhoneNumberAndCreateUser(decryptedSub) {
  try {
    const userRef = collection(db, "users");

    const q = query(userRef, where("phoneNumber", "==", decryptedSub));

    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      const userDoc = querySnapshot.docs[0]; // Get the first matching document
      const userData = userDoc.data();

      console.log("Phone number exists. Returning UUID:", userData.uuid);

      // Save user data in sessionStorage for future use
      sessionStorage.setItem(
        "AI_UserData",
        JSON.stringify({
          uuid: userData.uuid,
          phone: userData.phoneNumber,
          date: userData.date,
          talking_photo_limit: userData.talking_photo_limit,
          avatar_limit: userData.avatar_limit,
          streaming_limit: userData.streaming_limit,
          upload_limit: userData.upload_limit,
          image_generation_limit: userData.image_generation_limit,
        })
      );
      await ensureStreamingLimitByCountry(userData.phoneNumber); // ✅ safe here

      await UpdateAnalytics("logins");

      return userData.uuid; // Return the UUID of the found user
    } else {
      // User not found, create a new user
      console.log("Phone number not found. Creating a new user...");
      await UpdateAnalytics("logins");
      return await createUserAndStoreData(decryptedSub);
    }
  } catch (error) {
    console.error("Error checking or creating user:", error);
    throw error; // Re-throw the error for further handling, if needed
  }
}

// Function to create an anonymous user and store the data in Firestore
async function createUserAndStoreData(decryptedSub) {
  try {
    // Sign in anonymously to Firebase
    const userCredential = await signInAnonymously(auth);
    const user = userCredential.user;

    // 👇 fetch country as plain text
    const country = await getCountryCode();

    const userRef = doc(db, "users", decryptedSub);

    const userData = {
      phoneNumber: decryptedSub,
      uuid: user.uid,
      date: formattedDate,
      image_generation_limit: 10,
      talking_photo_limit: 70,
      avatar_limit: 70,
      // ✅ AE → 900, others → 120
      streaming_limit: country === "AE" ? 900 : 120,
      upload_limit: 10,
      // (optional) store country if useful later
      country,
    };

    await setDoc(userRef, userData);
    await UpdateAnalytics("users");
    console.log("User created and data saved:", userData);
    return user;
  } catch (error) {
    console.error("Error creating user and storing data:", error);
  }
}

// ⬇️ Add this
export async function GetStreamingLimit(phone) {
  if (!phone) return 0;
  try {
    const userRef = doc(db, "users", String(phone));
    const snap = await getDoc(userRef);
    if (!snap.exists()) {
      console.warn("GetStreamingLimit: user doc not found for", phone);
      return 0;
    }
    const data = snap.data();
    const remaining = Number(data?.streaming_limit ?? 0);

    // Optional: keep sessionStorage in sync for quick UI reads
    const s = JSON.parse(sessionStorage.getItem("AI_UserData") || "{}");
    s.streaming_limit = remaining;
    sessionStorage.setItem("AI_UserData", JSON.stringify(s));

    return remaining;
  } catch (e) {
    console.error("GetStreamingLimit error:", e);
    return 0;
  }
}

export async function UpdateUserLimits(type, phone, duration) {
  const userRef = doc(db, "users", phone);
  const docSnap = await getDoc(userRef);

  try {
    if (docSnap.exists()) {
      const userData = docSnap.data();

      // For image upload limits
      if (!duration) {
        const uploadLimits = userData.upload_limit;
        const newUploadLimit = uploadLimits - 1;

        await updateDoc(userRef, { [type]: newUploadLimit });

        // Update sessionStorage
        const userDataFromSession = JSON.parse(
          sessionStorage.getItem("AI_UserData")
        );
        if (userDataFromSession) {
          userDataFromSession.upload_limit = newUploadLimit;
          sessionStorage.setItem(
            "AI_UserData",
            JSON.stringify(userDataFromSession)
          );
        }
      } else {
        // For other types with a duration
        let updatedLimit = userData[type] - duration;
        if (updatedLimit < 0) {
          updatedLimit = 0; // Prevent negative limits
        }

        await updateDoc(userRef, { [type]: updatedLimit });

        // Update sessionStorage
        const userDataFromSession = JSON.parse(
          sessionStorage.getItem("AI_UserData")
        );
        if (userDataFromSession) {
          userDataFromSession[type] = updatedLimit;
          sessionStorage.setItem(
            "AI_UserData",
            JSON.stringify(userDataFromSession)
          );
        }

        console.log("Limit Updated:", updatedLimit);
      }
    } else {
      console.log("User not found");
    }
  } catch (e) {
    console.error("Error in updating limits:", e);
  }
}

export async function UpdateAnalytics(type) {
  try {
    const analyticsRef = doc(db, "analytics", formattedDate); // Reference to today's analytics document

    // Check if the document exists
    const docSnap = await getDoc(analyticsRef);

    if (docSnap.exists()) {
      // Increment the specified field by 1
      await updateDoc(analyticsRef, {
        [type]: increment(1), // Use Firebase's increment function
      });
      console.log(`Analytics updated: Incremented "${type}" by 1.`);
    } else {
      const initialData = {
        [type]: 1, // Initialize the field with 1
      };

      await setDoc(analyticsRef, initialData);
      console.log("Analytics document created:", initialData);
    }
  } catch (e) {
    console.error("Error in updating analytics:", e);
  }
}

export async function AddVideo(category, video_id, title) {
  const uuid = JSON.parse(sessionStorage.getItem("AI_UserData")).uuid;
  const phonenumber = JSON.parse(sessionStorage.getItem("AI_UserData")).phone;

  try {
    const userRef = doc(db, category, uuid); // Reference to user's document
    const docSnap = await getDoc(userRef); // Retrieve the document

    let data;

    if (docSnap.exists()) {
      const existingData = docSnap.data();

      const updatedData = existingData || {};

      updatedData[video_id] = { title: title };

      data = updatedData;
    } else {
      data = {
        [video_id]: {
          title: title,
        },
      };
    }

    await setDoc(userRef, data, { merge: true });

    if (category === "streaming") {
      UpdateUserLimits("streaming_limit", phonenumber, 3);
    }
    if (category === "avatar") {
      UpdateUserLimits("avatar_limit", phonenumber, 3);
    }
    if (category === "talking_photo") {
      UpdateUserLimits("talking_photo_limit", phonenumber, 3);
    }

    console.log("Video added", data);

    return "Your Video is being generated";
  } catch (error) {
    console.error("Error adding video and storing data:", error);
    return "Error Generating Video";
  }
}

export async function getVideosFirebase(category, uuid) {
  try {
    const userRef = doc(db, category, uuid);
    const docSnap = await getDoc(userRef);

    if (docSnap.exists()) {
      const existingData = docSnap.data();

      // Object.entries(existingData).forEach(async ([key, value]) => {
      //     if (value.status) {
      //         console.log(key, "is already completed");
      //     } else {
      //         const statusData = await getVideoStatus(key);
      //         if (statusData.status === "completed") {
      //             // Merge existing value with the new statusData
      //             const updatePayload = {
      //                 [key]: {
      //                     ...value, // Keep the existing value
      //                     ...statusData, // Add/Update with new statusData
      //                 },
      //             };
      //             await updateDoc(userRef, updatePayload);
      //         } else {
      //             console.log(key, "is not completed yet");
      //         }
      //     }
      // });

      // console.log(existingData)
      return existingData;
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error adding video and storing data:", error);
    return "Error Generating Video";
  }
}

export async function updateSingleVideoStatus(category, uuid, id) {
  let updatePayload;
  try {
    const userRef = doc(db, category, uuid); // Reference to the document
    const docSnap = await getDoc(userRef); // Fetch the document

    if (docSnap.exists()) {
      const existingData = docSnap.data(); // Get the existing data

      // Check if the specific video exists in the document
      if (existingData[id]) {
        const videoData = existingData[id];

        if (videoData.status === "completed") {
          console.log(id, "is already completed");
          return existingData;
        } else {
          // Fetch the status of the specific video
          const statusData = await getVideoStatus(id);
          if (statusData.status === "completed") {
            updatePayload = {
              [id]: {
                ...videoData, // Keep the existing value
                ...statusData, // Add/Update with new status data
              },
            };
            await updateDoc(userRef, updatePayload); // Update only the specific video
            console.log(id, "has been updated to completed");
          } else {
            console.log(id, "is not completed yet");
            return 0;
          }
        }
      } else {
        console.log(id, "does not exist in the document");
      }

      return updatePayload;
    } else {
      console.log("Document does not exist");
      return [];
    }
  } catch (error) {
    console.error("Error updating video status:", error);
    return "Error Updating Video";
  }
}

export async function updateExpired(category, uuid, id) {
  let updatePayload;
  try {
    const userRef = doc(db, category, uuid); // Reference to the document
    const docSnap = await getDoc(userRef); // Fetch the document

    if (docSnap.exists()) {
      const existingData = docSnap.data(); // Get the existing data
      if (existingData[id]) {
        const videoData = existingData[id];
        const statusData = await getVideoStatus(id);

        updatePayload = {
          [id]: {
            ...videoData, // Keep the existing value
            ...statusData, // Add/Update with new status data
          },
        };
        await updateDoc(userRef, updatePayload); // Update only the specific video
        console.log(id, "has been updated to completed");
      } else {
        console.log(id, "does not exist in the document");
      }

      return updatePayload;
    } else {
      console.log("Document does not exist");
      return [];
    }
  } catch (error) {
    console.error("Error updating video status:", error);
    return "Error Updating Video";
  }
}

// Old function
// export async function uploadPhotoFirebase(image) {
//     const uuid = JSON.parse(sessionStorage.getItem('AI_UserData')).uuid;

//     const userRef = doc(db, 'image_uploads', uuid);  // Reference to the user's document

//     try {
//         // Get the user's document
//         const docSnap = await getDoc(userRef);

//         // If the document exists
//         if (docSnap.exists()) {
//             // Retrieve the current data
//             const existingData = docSnap.data();
//             const updatedImages = [...existingData.images, image]; // Append the new image to the images array

//             // Update the document with the new images array
//             await setDoc(userRef, { images: updatedImages }, { merge: true });

//             console.log('Image uploaded successfully');
//             return 'Image uploaded successfully';
//         } else {
//             // If the document doesn't exist, create it with the image array
//             await setDoc(userRef, { images: [image] });

//             console.log('New user document created and image uploaded');
//             return 'New user document created and image uploaded';
//         }
//     } catch (error) {
//         console.error('Error uploading image:', error);
//         return 'Error uploading image';
//     }
// }

// New function
export async function uploadPhotoFirebase(data) {
  const uuid = JSON.parse(sessionStorage.getItem("AI_UserData")).uuid;
  const userRef = doc(db, "image_uploads", uuid); // Reference to the user's document in Firestore

  try {
    const docSnap = await getDoc(userRef); // Check if the document exists
    const newImage = {
      id: data.talking_photo_id, // Use the id from the data object
      image_url: data.talking_photo_url, // Use the image_url from the data object
    };

    if (docSnap.exists()) {
      const existingData = docSnap.data(); // Get the existing data

      const existingImages = existingData.images || [];

      const updatedImages = [...existingImages, newImage];

      await setDoc(userRef, { images: updatedImages }, { merge: true });
      await UpdateAnalytics("uploads");
      console.log("Image uploaded successfully");

      return "Image uploaded successfully";
    } else {
      await setDoc(userRef, { images: [newImage] });
      await UpdateAnalytics("uploads");
      console.log("New user document created and image uploaded");
      return "New user document created and image uploaded";
    }
  } catch (error) {
    console.error("Error uploading image:", error);
    return "Error uploading image";
  }
}

export async function getUploads() {
  const sessionUploads = JSON.parse(
    sessionStorage.getItem("AI_Uploads") || "null"
  );
  if (sessionUploads) {
    console.log(`✅ [getUploads] Source: SESSIONSTORAGE (AI_Uploads)`);
    console.log(
      `📦 [getUploads] Loaded ${
        Array.isArray(sessionUploads) ? sessionUploads.length : 0
      } uploads from sessionStorage`
    );
    return sessionUploads;
  } else {
    console.log("🔍 [getUploads] Not in sessionStorage, checking Firestore...");
    const uuid = JSON.parse(sessionStorage.getItem("AI_UserData"))?.uuid;

    if (!uuid) {
      console.warn("⚠️ [getUploads] No UUID found in sessionStorage");
      return [];
    }

    const userRef = doc(db, "image_uploads", uuid); // Reference to the user's document

    try {
      const docSnap = await getDoc(userRef);

      if (docSnap.exists()) {
        const existingData = docSnap.data();
        console.log(
          `✅ [getUploads] Source: FIRESTORE (image_uploads/${uuid})`
        );
        sessionStorage.setItem(
          "AI_Uploads",
          JSON.stringify(existingData.images)
        );
        console.log(
          `📦 [getUploads] Loaded ${
            Array.isArray(existingData.images) ? existingData.images.length : 0
          } uploads from Firestore and cached to sessionStorage`
        );
        return existingData.images;
      } else {
        console.log(
          `📭 [getUploads] Source: NONE - No uploads found in Firestore for user ${uuid}`
        );
        return [];
      }
    } catch (error) {
      console.error("❌ [getUploads] Error getting uploads:", error);
      return [];
    }
  }
}

async function cacheFirebase() {
  const userRef = doc(db, "cache", "avatars");

  try {
    // Get existing data
    const docSnap = await getDoc(userRef);
    let existingData = docSnap.exists() ? docSnap.data() : {};

    // Get cached data from sessionStorage
    const cachedStreaming =
      JSON.parse(sessionStorage.getItem("AI_Avatars")) || [];

    let updates = {};
    cachedStreaming.forEach((item, index) => {
      // Use a unique key for each item (e.g., item.id, or "stream_" + index)
      let key = `${index}`;
      updates[key] = item;
    });

    // Update Firestore without nesting under 'avatars'
    await updateDoc(userRef, updates);

    console.log("Cache updated successfully!");
  } catch (error) {
    console.error("Error updating Firestore:", error);
  }
}

export async function getCachedData(type) {
  const sessionStorageMap = {
    avatars: "AI_Avatars",
    streaming_avatars: "AI_Streaming",
    talking_photos: "AI_TalkingPhotos",
    voices: "AI_Voices",
  };

  // Convert type to lowercase and check if it exists in the map
  const sessionStorageKey = sessionStorageMap[type.toLowerCase()];
  console.log("sessionStorageKey : ", sessionStorageKey);
  if (!sessionStorageKey) {
    console.error("Invalid type provided:", type);
    return;
  }

  const userRef = doc(db, "cache", type);

  try {
    const existingSessionData = sessionStorage.getItem(sessionStorageKey);
    if (existingSessionData) {
      console.log(
        `✅ [getCachedData] Source: SESSIONSTORAGE (${sessionStorageKey})`
      );
      const parsedData = JSON.parse(existingSessionData);
      const arr = parsedData ? Object.values(parsedData) : [];
      console.log(
        `📦 [getCachedData] Loaded ${arr.length} items from sessionStorage`
      );
      return arr;
    }

    console.log(
      `🔍 [getCachedData] Not in sessionStorage, checking Firestore...`
    );
    const docSnap = await getDoc(userRef);

    if (docSnap.exists()) {
      const data = docSnap.data();
      console.log(`✅ [getCachedData] Source: FIRESTORE (cache/${type})`);
      // Save to session storage
      sessionStorage.setItem(sessionStorageKey, JSON.stringify(data));
      const arr = data ? Object.values(data) : [];
      console.log(
        `📦 [getCachedData] Loaded ${arr.length} items from Firestore and cached to sessionStorage`
      );
      return arr;
    } else {
      console.warn(
        `⚠️ [getCachedData] No document found for ${type} in Firestore.`
      );
      console.log(`📭 [getCachedData] Source: NONE - Cache does not exist yet`);
    }
  } catch (error) {
    console.error(
      "❌ [getCachedData] Error fetching data from Firestore:",
      error
    );
  }
}

export async function UpdateExpiredTalkingPhoto() {
  console.log("🔄 [UpdateExpiredTalkingPhoto] Checking for expired photos...");
  // Get data from sessionStorage and parse it
  const talkingPhotosStorage = sessionStorage.getItem("AI_TalkingPhotos");
  const uploadsStorage = sessionStorage.getItem("AI_Uploads");

  const talkingphotos = talkingPhotosStorage
    ? Object.values(JSON.parse(talkingPhotosStorage))
    : [];
  const uploads = uploadsStorage
    ? Object.values(JSON.parse(uploadsStorage))
    : [];
  const uuid =
    JSON.parse(sessionStorage.getItem("AI_UserData") || "{}")?.uuid || "";

  console.log(
    `📊 [UpdateExpiredTalkingPhoto] Current cache: ${talkingphotos.length} talking photos, ${uploads.length} uploads`
  );

  // Helper function to check expiry status of a given photo list
  const isExpired = (photos) => {
    if (!Array.isArray(photos) || photos.length === 0) return false;
    const expires = getExpiresFromUrl(photos[0]?.image_url);
    return isTimestampValid(expires);
  };

  // Check expiry status for both talkingphotos and uploads

  const expiredTalkingPhotos = isExpired(talkingphotos);
  const expiredUploads = isExpired(uploads);

  console.log(
    `⏰ [UpdateExpiredTalkingPhoto] Expiry check - Talking Photos: ${
      expiredTalkingPhotos ? "EXPIRED ❌" : "VALID ✅"
    }, Uploads: ${expiredUploads ? "EXPIRED ❌" : "VALID ✅"}`
  );

  // Exit early if neither is expired
  if (!expiredTalkingPhotos && !expiredUploads) {
    console.log(
      "✅ [UpdateExpiredTalkingPhoto] No expired photos found, skipping refresh"
    );
    return;
  }

  // Fetch data only once if either is expired
  try {
    console.log(
      "🌐 [UpdateExpiredTalkingPhoto] Source: HEYGEN API (https://api.heygen.com/v1/talking_photo.list)"
    );
    console.log(
      "⏳ [UpdateExpiredTalkingPhoto] Fetching fresh data from HeyGen API..."
    );
    const response = await axios.get(
      `https://api.heygen.com/v1/talking_photo.list`,
      {
        headers: {
          "x-api-key": process.env.REACT_APP_X_KEY,
        },
      }
    );
    const heygentalkingphotos = response.data.data;
    console.log(
      `✅ [UpdateExpiredTalkingPhoto] Received ${
        heygentalkingphotos?.length || 0
      } photos from HeyGen API`
    );

    // Helper function to update sessionStorage
    const updateSessionStorage = (key, oldPhotos) => {
      if (!Array.isArray(oldPhotos) || oldPhotos.length === 0) {
        console.log(
          `⏭️ [UpdateExpiredTalkingPhoto] Skipping ${key} - no photos to update`
        );
        return [];
      }
      const photoIds = new Set(oldPhotos.map((photo) => photo.id));
      const updatedPhotos = heygentalkingphotos.filter((photo) =>
        photoIds.has(photo.id)
      );

      if (updatedPhotos.length > 0) {
        sessionStorage.setItem(key, JSON.stringify(updatedPhotos));
        console.log(
          `✅ [UpdateExpiredTalkingPhoto] ${key} successfully updated with ${updatedPhotos.length} fresh URLs`
        );
        return updatedPhotos;
      } else {
        console.log(
          `⚠️ [UpdateExpiredTalkingPhoto] No updates were made to ${key} - photos not found in HeyGen response`
        );
        return [];
      }
    };

    // Update sessionStorage if the data has expired
    let updatedTalkingPhotos = [];
    if (expiredTalkingPhotos) {
      console.log(
        "🔄 [UpdateExpiredTalkingPhoto] Updating expired talking photos..."
      );
      updatedTalkingPhotos = updateSessionStorage(
        "AI_TalkingPhotos",
        talkingphotos
      );
    }

    let updatedUploads = [];
    if (expiredUploads) {
      console.log("🔄 [UpdateExpiredTalkingPhoto] Updating expired uploads...");
      updatedUploads = updateSessionStorage("AI_Uploads", uploads);
    }

    // Add updated values to Firebase if data is updated
    if (updatedTalkingPhotos.length > 0) {
      try {
        const talkingPhotosObject = updatedTalkingPhotos.reduce(
          (obj, item, index) => {
            obj[`${index}`] = item; // You can customize the key name here (e.g., photo_0, photo_1, etc.)
            return obj;
          },
          {}
        );

        const docRef = doc(db, "cache", "talking_photos"); // Specify document name
        await setDoc(docRef, talkingPhotosObject);

        console.log(
          `✅ [UpdateExpiredTalkingPhoto] Data successfully updated to Firestore (cache/talking_photos)`
        );
      } catch (e) {
        console.error("Error adding document to Firebase:", e);
      }
    }

    if (updatedUploads.length > 0) {
      try {
        const docRef = doc(db, "image_uploads", uuid); // Specify document name
        await setDoc(docRef, { images: updatedUploads });

        console.log(
          `✅ [UpdateExpiredTalkingPhoto] Data successfully updated to Firestore (image_uploads/${uuid})`
        );
      } catch (e) {
        console.error("Error adding document to Firebase:", e);
      }
    }
  } catch (error) {
    console.error(
      "❌ [UpdateExpiredTalkingPhoto] Error fetching talking photos from HeyGen API:",
      error
    );
  }
}

// const addDataToFirebase = async (collectionName, documentName, data) => {
//     try {
//         // Create a reference to the document in Firestore
//         const docRef = doc(db, collectionName, documentName); // Specify document name
//         await setDoc(docRef, data);

//         console.log(`Data successfully added to document '${documentName}' in collection '${collectionName}'`);
//     } catch (e) {
//         console.error("Error adding document to Firebase:", e);
//     }
// };

function isTimestampValid(expires) {
  const expiryDate = new Date(expires * 1000); // Convert to milliseconds
  const now = new Date();
  console.log(expiryDate);

  return expiryDate > now ? !expiryDate.toISOString() : true;
}

function getExpiresFromUrl(url) {
  const params = new URL(url).searchParams;
  const expires = params.get("Expires");
  return expires ? parseInt(expires, 10) : null;
}

// updateVideoStatus("talking_photos", "nknfoSJ0k9OMp2C2ID9t1vNjfxe2")

// const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxNWFjMGU3ZjU5MmZlNTEzZTRhOWQ0ZWE5ZTk0OGFmYSIsImlwYWRkcmVzcyI6IjExNC4xMC4yMC4yNTAiLCJ1c2VyX3R5cGUiOiJpbTMiLCJkZXZpY2VfaWQiOiI3OTQ1YmZlOTRiMGVhZWViIiwiY3VzdGlkIjoiYjhkNjA5YWQyZjExODkzMGU3MzdiZGRkNmE4MDIyY2UiLCJwcm9maWxlcyI6IiIsImxhbmd1YWdlIjoiSUQiLCJzdWJzdHlwZSI6IjliN2EyMTgxODQ5ZTI5YTYxMjlhOGFhZmRkYTE5YzM1IiwiZXhwIjoxNzM2NDgzNDk1LCJpYXQiOjE3MzY0ODI4OTUsInZlcnNpb24iOiI4Mi41LjAifQ.btgp9j5tv3kie2AjvkgwEw-jZDHDTs3v20hM1oB2DfQ';
// decodeJWTAndDecryptSub(token);
